export default {"src":"/a/r/be1.10/_next/static/media/start.a6a2c286.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};